module.exports = __webpack_public_path__ + "img/live-logo.c105b197.png";